<template>
  <main>
    <div class="py-4 container-fluid">
      <GridRow>
        <GridCol :size="12">
          <MetaSection :title="periode_active?.name || '-'">
            <div class="text-right">
              <!-- <div class="d-flex flex-row gap-3">
                <argon-button :outline="true">Kembali</argon-button>
                <argon-button>Kirim</argon-button>
              </div> -->

              <div class="d-flex gap-3">
                <router-link :to="{ name: 'Koreksi Hasil Penilaian' }">
                  <button class="btn btn-secondary">
                    Kembali
                  </button>
                </router-link>
                <!-- <button class="btn btn-outline-secondary mr-2">Tolak</button> -->
                <button class="btn btn-secondary" v-if="!is_correction" @click="setCorrection(true)">Koreksi Hasil</button>
                <template v-else>
                  <button class="btn btn-outline-secondary mr-2" @click="setCorrection(false)">Batalkan</button>
                  <button class="btn btn-secondary" @click="submit()">Simpan</button>
                </template>
              </div>
            </div>
          </MetaSection>
        </GridCol>
        <GridCol :size="12">
            <cards title="Form Realisasi KPI" :withmin="false">
              <div class="d-flex gap-4">
                <div class="bg-secondary rounded-2 p-0" style="width: 92px !important; height: 92px !important; "></div>
                
                <div class="d-flex flex-column gap-3 w-100">
                  <div class="row ">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Nama</span>
                      <span>{{ employee?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Jabatan</span>
                      <span>{{ employee?.jabatan?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Unit Kerja</span>
                      <span>{{ employee?.unitkerja?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Direct Supervisor</span>
                      <span>{{ employee?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">No</span>
                      <span>{{ employee?.nip || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Posisi</span>
                      <span>{{ employee?.position || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Periode KPI</span>
                      <span>{{ periode_active?.name || '-' }}</span>
                    </div>
                    <div class="col d-flex flex-column">
                      <span class="text-secondary text-xs">Immediate Supervisor</span>
                      <span>{{ employee?.unitkerja?.leader?.name || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </cards>
        </GridCol>
        
        <GridCol :size="12">
          <!-- <cards title="Form Realisasi KPI" useFooter> -->
            <!-- <template v-slot:footer>
              <div class="text-right">
                <div class="d-flex flex-row-reverse gap-2">
                  <ArgonButton>Lanjutkan</ArgonButton>
                  <ArgonButton :to="{ name: 'Realisasi Target' }" isRouteLink outline>Batalkan</ArgonButton>
                </div>
              </div>
            </template> -->

          <cards title="Form Realisasi KPI" class="mt-4">
            <tabbed-pane
              :tabs="tabs"
            >
              <div class="tab-pane fade show active"
                id="pills-penilaian-kinerja"
                role="tabpanel"
                aria-labelledby="pills-penilaian-kinerja-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Kinerja</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <!-- <pre>{{ list_penilaian_kinerja }}</pre> -->
                <template v-if="list_penilaian_kinerja?.list_kpi?.length > 0">
                  <form-group
                    v-for="(item,index) in list_penilaian_kinerja.list_kpi"
                    :key="index"
                    :label="item?.kpi || '-'"
                    :hint="item?.sub_jumlah || item?.sub_jumlah === 0 ? item?.sub_jumlah : (sumBobotSubKpi(item?.sub_kpi || []))"
                  >
                    <div class="table-responsive">
                      <table class="table align-middle border border-1 border-light">
                        <thead class="table-light">
                          <tr>
                            <th scope="col">Sub KPI</th>
                            <th scope="col">Target</th>
                            <th scope="col">Satuan</th>
                            <th scope="col">Bobot</th>
                            <th scope="col">Realisasi</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(sub, i) in item?.sub_kpi"
                            :key="i"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <p>{{ sub?.nama_aspek_kpi || '-' }}</p>
                              <p v-if="sub?.catatan" class="text-xs"> {{ sub?.catatan || '-' }}</p>
                            </td>
                            <td width="150">
                              <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                                <input
                                  v-model="this.list_penilaian_kinerja.list_kpi[index].sub_kpi[i].target"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                              <p v-else>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.target || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                            <td width="100">
                              <p class="text-capitalize">{{ getSatuan(sub?.satuan) || '-' }}</p>
                            </td>
                            <td width="100">
                              <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                                <input
                                  v-model="this.list_penilaian_kinerja.list_kpi[index].sub_kpi[i].bobot"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                              <p v-else>{{ sub?.bobot ? sub.bobot +'%' : '-' }}</p>
                            </td>
                            <td width="150">
                              <p>
                                <span v-if="sub?.satuan?.toLowerCase() === 'rupiah'">
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      style: 'currency',
                                      currency: 'IDR',
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }}
                                </span>
                                <span v-else>
                                  {{
                                    new Intl.NumberFormat('id-ID', {
                                      minimumFractionDigits: 0,
                                    }).format(sub?.realisasi || '0')
                                  }} 
                                  <span class="text-capitalize">{{ (sub?.satuan?.toLowerCase() === 'persen' ? '%' : sub?.satuan) || '' }}</span>
                                </span>
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </form-group>
                </template>

                <template v-if="['-'].includes(status_koreksi) && is_correction">
                  <div
                    v-if="!is_note_penilaian_kinerja"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_kinerja = !is_note_penilaian_kinerja"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_kinerja"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_kinerja"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-penugasan-khusus"
                role="tabpanel"
                aria-labelledby="pills-penugasan-khusus-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penugasan Khusus</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <!-- <pre>{{ list_penugasan_khusus }}</pre> -->
                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" colspan="2">Jenis Penugasan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- <template v-if="list_penugasan_khusus?.penugasan?.length > 0"> -->
                        <template v-if="list_penugasan_khusus?.length > 0">
                          <tr
                            v-for="(item, index) in list_penugasan_khusus"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td colspan="2">
                              <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                                <input
                                  v-model="this.list_penugasan_khusus[index].name"
                                  type="text"
                                  class="form-control"
                                />
                              </form-group>
                              
                              <!-- <p class="px-2 mt-2">Mengikuti pelatihan nasional maupun internasional dalam setiap bulan </p> -->
                              <div v-else class="py-3 px-3">{{ item?.name || '-' }}</div>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Nilai Penugasan Khusus</th>
                          <th scope="col">{{ list_penugasan_khusus?.length > 0 ? '0.25' : '0' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['-'].includes(status_koreksi) && is_correction">
                  <div
                    v-if="!is_note_penugasan_khusus"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penugasan_khusus = !is_note_penugasan_khusus"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penugasan_khusus"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penugasan_khusus"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-pengurangan"
                role="tabpanel"
                aria-labelledby="pills-pengurangan-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Pengurangan</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Tingkat Permasalahan</th>
                          <th scope="col">Jumlah</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- <template v-if="list_pengurangan?.pengurangan?.length > 0"> -->
                        <template v-if="list_pengurangan?.length > 0">
                          <tr
                            v-for="(item, index) in list_pengurangan"
                            :key="item"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">{{ item?.tingkat_permasalahan || '-' }}</div>
                            </td>
                            <td width="10">
                              <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                                <input
                                  v-model="this.list_pengurangan[index].jumlah_permasalahan"
                                  type="number"
                                  min="0"
                                  class="form-control"
                                />
                              </form-group>
                              <span v-else>{{ item?.jumlah_permasalahan || 0 }}</span>
                            </td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="2" class="text-center">-</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <template v-if="['-'].includes(status_koreksi) && is_correction">
                  <div
                    v-if="!is_note_pengurangan"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_pengurangan = !is_note_pengurangan"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_pengurangan"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_pengurangan"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

              <div class="tab-pane fade show"
                id="pills-kompetensi"
                role="tabpanel"
                aria-labelledby="pills-kompetensi-tab"
              >

                <!-- <pre>{{ list_kompetensi_inti }}</pre> -->
                <template v-if="list_kompetensi_inti.length > 0">
                  <div class="mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Inti</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <div
                    v-for="(item, index) in list_kompetensi_inti"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.kompetensi || '-' }}</h6>
                      <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                        <input
                          type="number"
                          class="form-control"
                          v-model="list_kompetensi_inti[index].nilai"
                          min="0"
                          max="5"
                          @change="checkLimitInput('inti', index)"
                        >
                      </form-group>
                      <span v-else>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" width="20">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <!-- <pre>{{ list_kompetensi_manajerial }}</pre> -->
                <template v-if="list_kompetensi_manajerial.length > 0">
                  <div class="mt-5 mb-4 d-flex items-center justify-content-between">
                    <h5>Kompetensi Manajerial</h5>
                    <!-- <span>
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </span> -->
                  </div>

                  <div
                    v-for="(item, index) in list_kompetensi_manajerial"
                    :key="item"
                    class="rounded-2 border border-1 p-3 mb-4"
                  >
                    <div class="d-flex justify-content-between items-center">
                      <h6 class="mt-2">{{ item?.name || '-' }}</h6>
                      <form-group v-if="['-'].includes(status_koreksi) && is_correction">
                        <input
                          type="number"
                          class="form-control"
                          v-model="list_kompetensi_manajerial[index].nilai"
                          min="0"
                          max="5"
                          @change="checkLimitInput('manajerial', index)"
                        >
                      </form-group>
                      <span v-else>{{ item?.nilai || '-' }}</span>
                    </div>

                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" width="20">
                            <small>Level</small>
                          </th>
                          <th scope="col">
                            <small>Deskripsi</small>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(sub, i) in 5"
                          :key="sub"
                        >
                          <tr
                            v-if="item?.list_kompetensi?.['level'+ (i +1)]"
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <span class="px-2">{{ i + 1 }}</span>
                            </td>
                            <td>
                              <p class="mt-3 text-wrap">{{ item?.list_kompetensi?.['level'+ (i +1)] || '-' }}</p>
                            </td>
                          </tr>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </template>

                <template v-if="['-'].includes(status_koreksi) && is_correction">
                  <div
                    v-if="!is_note_kompetensi"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_kompetensi = !is_note_kompetensi"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_kompetensi"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_kompetensi"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>

                <form-group class="mt-3">
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Jumlah</th>
                          <th scope="col" class="border-bottom-1 border-white">{{ total_nilai }}</th>
                        </tr>
                        <tr>
                          <th scope="col" class="border-bottom-1 border-white">Nilai</th>
                          <th scope="col" class="border-bottom-1 border-white" width="60">{{ nilai_kompetensi }}</th>
                        </tr>
                        <tr>
                          <th scope="col">Jumlah Maksimal Jabatan</th>
                          <th scope="col">{{ max_jabatan }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>
              </div>

              <div class="tab-pane fade show"
                id="pills-penilaian-akhir"
                role="tabpanel"
                aria-labelledby="pills-penilaian-akhir-tab"
              >
                
                <div class="mb-4 d-flex items-center justify-content-between">
                  <h5>Penilaian Akhir</h5>
                  <!-- <span>
                    <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                  </span> -->
                </div>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr>
                          <th scope="col">Kategori</th>
                          <th scope="col">Nilai</th>
                          <th scope="col">Bobot</th>
                          <th scope="col">Nilai Akhir</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-if="!data_penilaian_akhir"
                          class="border border-bottom-1 border-light"
                        >
                          <td colspan="4" class="text-center py-4">Submit kompetensi terlebih dahulu.</td>
                        </tr>

                        <template v-else>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Nilai Kinerja</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.average_kinerja || data_penilaian_akhir?.nilai_kinerja?.average_kinerja || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.bobot_kinerja || data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja ? (data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.bobot_kinerja || data_penilaian_akhir?.nilai_kinerja?.bobot_kinerja) +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_kinerja?.nilai_akhir_kinerja || data_penilaian_akhir?.nilai_kinerja?.nilai_akhir_kinerja || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Rata-rata Perilaku Kompetensi</div>
                            </td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.average_kompetensi || data_penilaian_akhir?.kompetensi?.average_kompetensi || 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.bobot_kompetensi || data_penilaian_akhir?.kompetensi?.bobot_kompetensi ? (data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.bobot_kompetensi || data_penilaian_akhir?.kompetensi?.bobot_kompetensi) +'%' : 0 }}</td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.kompetensi?.nilai_akhir_kompetensi || data_penilaian_akhir?.kompetensi?.nilai_akhir_kompetensi || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Penugasan Khusus, Rangkap Jabatan, Inovasi & Kreatifitas</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.penugasan_khusus || data_penilaian_akhir?.penugasan_khusus || 0 }}</td>
                          </tr>
                          <tr
                            class="border border-bottom-1 border-light"
                          >
                            <td>
                              <div class="py-3 px-3">Faktor Pengurang KPI</div>
                            </td>
                            <td></td>
                            <td></td>
                            <td>{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.pengurang || data_penilaian_akhir?.pengurang || 0 }}</td>
                          </tr>

                        </template>
                      </tbody>
                    </table>
                  </div>
                </form-group>

                <form-group>
                  <div class="table-responsive">
                    <table class="table align-middle border border-1 border-light">
                      <thead class="table-light">
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col" class="border-bottom-1 border-white">Nilai Akhir</th>
                          <th scope="col" class="border-bottom-1 border-white" width="140">{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.nilai_akhir || data_penilaian_akhir?.nilai_akhir || 0 }}</th>
                        </tr>
                        <tr
                          class="border border-bottom-1 border-light"
                        >
                          <th scope="col">Indeks</th>
                          <th scope="col">{{ data_penilaian_akhir?.penilaian_akhir?.koreksi?.indeks || data_penilaian_akhir?.indeks || '-' }}</th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                </form-group>

                <template v-if="['-'].includes(status_koreksi) && is_correction">
                  <div
                    v-if="!is_note_penilaian_akhir"
                    class="d-flex justify-content-end gap-4"
                  >
                    <button
                      type="button"
                      class="btn btn-outline-secondary"
                      @click="is_note_penilaian_akhir = !is_note_penilaian_akhir"
                    >
                      Berikan Catatan
                    </button>
                  </div>

                  <form-group
                    v-if="is_note_penilaian_akhir"
                    label="Tulis Catatan"
                  >
                    <p class="text-sm mb-2">Beri catatan untuk karyawan</p>
                    <textarea
                      v-model="note_penilaian_akhir"
                      class="form-control"
                      rows="5"
                      placeholder="Tulis catatan disini"
                    />
                  </form-group>
                </template>
              </div>

            </tabbed-pane>
          </cards>
        </GridCol>
      </GridRow>
    </div>
  </main>
</template>
    
<script>
import Cards from "@/components/CardComponent.vue";
import FormGroup from "@/components/FormGroup.vue";
// import FieldsetComponent from "@/components/FieldsetComponent.vue";
// import Select2 from 'vue3-select2-component';
import TabbedPane from "@/components/TabbedPane.vue";
// import ArgonButton from "@/components/ArgonButton.vue";
import MetaSection from '@/components/MetaSection.vue';
import GridRow from "@/components/grid/GridRow.vue";
import GridCol from "@/components/grid/GridCol.vue";
// import InputForm from "@/components/InputForm.vue";

import KpiPeriodeApi from "@/repository/api/KpiPeriodeApi";
import EmployeeApi from "@/repository/api/EmployeeApi";
import KoreksiApi from "@/repository/api/KoreksiApi";
import PenilaianKpiApi from "@/repository/api/PenilaianKpiApi";
import LaporanPersonalApi from "@/repository/api/LaporanPersonalApi";

export default {
  name: "realisasi-target",
  components: {
    // FieldsetComponent,
    FormGroup,
    Cards,
    TabbedPane,
    // ArgonButton,
    MetaSection,
    GridRow,
    GridCol,
    // InputForm,
  },
  data() {
    return {
      is_correction: false,

      tabs: {
        'Penilaian Kinerja':true,
        'Penugasan Khusus':false,
        'Pengurangan':false,
        'Kompetensi':false,
        'Penilaian Akhir':false
      },

      periode_active: null,
      employee: null,
      employee_id_login: null,

      list_penilaian_kinerja: [],
      is_note_penilaian_kinerja: false,
      note_penilaian_kinerja: '',
      
      list_penugasan_khusus: [],
      is_note_penugasan_khusus: false,
      note_penugasan_khusus: '',

      list_pengurangan: [],
      is_note_pengurangan: false,
      note_pengurangan: '',

      list_kompetensi_inti: [],
      list_kompetensi_manajerial: [],
      is_note_kompetensi: false,
      note_kompetensi: '',

      realisasi_kompetensi: null,

      data_penilaian_akhir: null,
      is_note_penilaian_akhir: false,
      note_penilaian_akhir: '',
      satuan_target: [
        {
          value: 'rupiah',
          label: 'Rupiah'        
        },
        {
          value: 'persen',
          label: 'Persen/Hari/Skala Nilai'        
        },
        {
          value: 'pcs',
          label: 'Pcs'        
        }
      ],
    };
  },
  computed: {
    periode_id() {
      return this.$route.params?.periode_id;
    },
    employee_id() {
      return this.$route.params?.employee_id;
    },
    realization_id() {
      return this.$route.params?.realization_id;
    },
    status_koreksi() {
      return this.$route.params?.status_koreksi;
    },
    correction_id() {
      return this.$route.params?.correction_id;
    },
    total_nilai() {
      let total = 0;

      if (this.list_kompetensi_inti.length > 0) {
        this.list_kompetensi_inti.forEach(item => {
          total += item.nilai;
        });
      }

      if (this.list_kompetensi_manajerial.length > 0) {
        this.list_kompetensi_manajerial.forEach(item => {
          total += item.nilai;
        });
      }

      return total;
    },
    
    nilai_kompetensi() {
      let total = 0;
      total = (this.total_nilai / this.max_jabatan) * 5;
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
    max_jabatan() {
      let total = 0;
      let inti = this.employee?.jabatan?.inti || 0;
      let manajerial = this.employee?.jabatan?.manajerial || 0;

      total = (inti * 5) + (manajerial * 5);
      if (!Number.isInteger(total)) total = total.toFixed(2);
      return total;
    },
  },
  watch: {
    periode_id() {},
    employee_id() {},
    realization_id() {},
    status_koreksi() {},
    correction_id() {},
    total_nilai() {},
    nilai_kompetensi() {},
    max_jabatan() {},
  },
  methods: {
    // openNoteModal(index) {
      //   this.step_1_detail_index = index;
    // },
    sumBobotSubKpi(data) {
      data = data.map((item) => Number.parseFloat(item?.bobot || 0));
      data = data.reduce((a, b) => a + b, 0);
      return data;
    },
    setCorrection(is_correction=false) {
      if (!is_correction) {
        this.$swal({
          icon: "warning",
          title: "Perubahan data akan hilang, lanjutkan?",
          showCancelButton: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            this.getData();

            this.is_correction = is_correction;
            
            this.is_note_penilaian_kinerja = false;
            this.note_penilaian_kinerja = '';
            this.is_note_penugasan_khusus = false;
            this.note_penugasan_khusus = '';
            this.is_note_pengurangan = false;
            this.note_pengurangan = '';
            this.is_note_kompetensi = false;
            this.note_kompetensi = '';
            this.is_note_penilaian_akhir = false;
            this.note_penilaian_akhir = '';
          }
        });

      } else {
        this.is_correction = is_correction;
      }
    },
    async checkLimitInput(type, index) {
      this.$store.state.loading = true;

      await PenilaianKpiApi.checkLimitInput({
        employee_id: this.employee_id,
        type,
        // type: this.employee.jabatan.jenis_kompetensi,
        nilai: (type === 'inti' ? this.list_kompetensi_inti[index].nilai : this.list_kompetensi_manajerial[index].nilai),
      })
        .then((resp) => {
          console.log(resp)
        })
        .catch((err) => {
          console.log(err)
          if (err?.response?.status === 412) {

            this.$swal({
              icon: "warning",
              title: err?.response?.data?.message,
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = err?.response?.data?.data?.[0]?.inti || 0;
            else this.list_kompetensi_manajerial[index].nilai = err?.response?.data?.data?.[0]?.manajerial || 0;

          } else {

            this.$swal({
              icon: "warning",
              title: 'Something wrong, please try again.',
            });

            if (type === 'inti') this.list_kompetensi_inti[index].nilai = 0;
            else this.list_kompetensi_manajerial[index].nilai = 0;
          }
        });

      this.$store.state.loading = false;
    },

    async getKpiPeriode() {
      await KpiPeriodeApi.get(this.periode_id)
        .then((response) => {
          this.periode_active = response?.data || {};
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getEmployee() {
      await EmployeeApi.get(this.employee_id)
        .then((resp) => {
          this.employee = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
      
      await this.getSessionUser();
      this.employee_id_login = this.$store.state?.sessionUser?.employee?.id || '';
    },
    async getPenilaianKinerja() {
      await KoreksiApi.getDetailPenilaianKinerja({
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penilaian_kinerja = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenugasanKhusus() {
      await KoreksiApi.getDetailPenugasanKhusus({
        // employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_penugasan_khusus = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPengurangan() {
      await KoreksiApi.getDetailPengurangan({
        // employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.list_pengurangan = resp?.data;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getKompetensi() {
      await KoreksiApi.getDetailKompetensi({
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.realisasi_kompetensi = resp?.data || null;
          // const list = resp?.data ? resp.data.map(item => { item.nilai = 0; return item; }) : [];
          const list = resp?.data?.nilai_perkompetensi;
          // console.log(list)

          this.list_kompetensi_inti = list.filter(item => item?.type === 'inti');
          this.list_kompetensi_manajerial = list.filter(item => item?.type === 'manajerial');
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async getPenilaianAkhir() {
      await KoreksiApi.getDetailPenilaianAkhir({
        // employee_id: this.employee_id,
        realization_id: this.realization_id,
        correction_id: this.correction_id,
      })
        .then((resp) => {
          // console.log(resp?.data)
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
          // this.data_penilaian_akhir = err?.response?.data || null;
        });
    },

    async getReportPenilaianAkhir() {
      await LaporanPersonalApi.getDetailPenilaianAkhir({
        employee_id: this.employee_id,
        realization_id: this.realization_id,
      })
        .then((resp) => {
          this.data_penilaian_akhir = resp?.data || null;
        })
        .catch((err) => {
          console.log(err)
        });
    },

    async submit() {
      this.$swal({
        icon: "warning",
        title: "Anda yakin ingin meyimpan koreksi?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.$store.state.loading = true;

            const correction_id = await this.createCorrection();
            await this.submitPenilaianKinerja(correction_id);
            await this.submitPenugasanKhusus(correction_id);
            await this.submitPengurangan(correction_id);
            await this.submitKompetensi(correction_id);
            await this.submitNotes(correction_id);

            this.$swal({
              icon: "success",
              title: 'Koreksi berhasil diajukan.',
            });

            this.$router.push({ name: 'Koreksi Hasil Penilaian' });
            this.$store.state.loading = false;

          } catch (error) {
            console.log(error)
            this.$store.state.loading = false;
            this.$swal({
              icon: "error",
              title: error?.response?.data?.message || 'Something wrong, please try again.',
            });
          }
        }
      });
    },
    async createCorrection() {
      const resp = await KoreksiApi.createKoreksi({
        realization_id: this.realization_id,
        created_by: this.employee_id_login,
      });
      return resp?.data?.id;
    },
    collectRealisasi() {
      const realisasi = [];
      if (this.list_penilaian_kinerja?.list_kpi) {
        this.list_penilaian_kinerja.list_kpi.forEach(item => {
          if (item?.sub_kpi) {
            item.sub_kpi.forEach(item_sub => {
              realisasi.push({
                kpiaspekpenilaianassignment_id: item_sub.assignment_id,
                kpisub_id: item_sub.subkpi_id,
                id: item_sub.id,
                bobot: item_sub.bobot,
                target: item_sub.target,
                realisasi: item_sub.realisasi,
                catatan: item_sub.catatan,
                satuan: item_sub.satuan,
              });
            });
          }
        });
      }
      return realisasi;
    },
    async submitPenilaianKinerja(correction_id) {
      const realisasi = this.collectRealisasi();
      await KoreksiApi.addKoreksiPenilaianKinerja({
        employee_id: this.employee_id,
        correction_id,
        realisasi: JSON.stringify(realisasi),
        id: this.list_penilaian_kinerja?.id,
      });
    },
    async submitPenugasanKhusus(correction_id) {
      if (!this.list_penugasan_khusus?.length) return;
      for (const item of this.list_penugasan_khusus) {
        await KoreksiApi.addKoreksiPenugasanKhusus({
          correction_id,
          name: item.name,
          penugasan_id: item.id,
        });
      }
    },
    async submitPengurangan(correction_id) {
      const pengurangan = [];
      if (this.list_pengurangan.length > 0) {
        this.list_pengurangan.forEach(item => {
          pengurangan.push({
            id: item.id,
            tingkat_permasalahan: item.tingkat_permasalahan,
            nilai: item.nilai,
            jumlah_permasalahan: item.jumlah_permasalahan,
          });
        });
      }
      await KoreksiApi.addKoreksiPengurangan({
        correction_id,
        pengurangan: JSON.stringify(pengurangan),
      });
    },
    async submitKompetensi(correction_id) {
      const kompetensi = [];
      if (this.realisasi_kompetensi?.nilai_perkompetensi?.length > 0) {
        this.realisasi_kompetensi.nilai_perkompetensi.forEach(item => {
          kompetensi.push({
            id: item.id,
            nilai: item.nilai,
            type: item.type,
          });
        });
      }
      await KoreksiApi.addKoreksiKompetensi({
        correction_id,
        employee_id: this.employee_id,
        id: this.realisasi_kompetensi?.id,
        kompetensi: JSON.stringify(kompetensi),
      });
    },
    async submitNote(correction_id, note, apiMethod) {
      if (!note) return;
      await apiMethod({
        correction_id,
        is_from_immediate: false,
        catatan: note,
      });
    },
    async submitNotes(correction_id) {
      await this.submitNote(correction_id, this.note_penilaian_kinerja, KoreksiApi.addNoteKoreksiPenilaianKinerja);
      await this.submitNote(correction_id, this.note_penugasan_khusus, KoreksiApi.addNoteKoreksiPenugasanKhusus);
      await this.submitNote(correction_id, this.note_pengurangan, KoreksiApi.addNoteKoreksiPengurangan);
      await this.submitNote(correction_id, this.note_kompetensi, KoreksiApi.addNoteKoreksiKompetensi);
      await this.submitNote(correction_id, this.note_penilaian_akhir, KoreksiApi.addNoteKoreksiPenilaianAkhir);
    },

    async getData() {
      this.$store.state.loading = true;
  
      await this.getKpiPeriode();
      await this.getEmployee();
      await this.getPenilaianKinerja();
      await this.getPenugasanKhusus();
      await this.getPengurangan();
      await this.getKompetensi();

      if (!this.correction_id) {
        await this.getReportPenilaianAkhir();
      } else {
        await this.getPenilaianAkhir();
      }
  
      this.$store.state.loading = false;
    },
    getSatuan(satuan) {
      let result = null
      try {
        result = this.satuan_target.find(({ value }) => value === satuan);
        result = result.label
      } catch (error) {
        result = satuan
      }
      return result
    }
  },
  async mounted() {
    await this.getData();
  },
};
</script>
    